export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/gb.6c5e14c1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};